import { Directive } from '@angular/core';
import { AbstractControl, FormControl, NG_VALIDATORS, ValidationErrors, Validator, ValidatorFn } from '@angular/forms';

@Directive({
  selector: '[appAbnValidator]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useClass: AbnValidatorDirective,
      multi: true
    }
  ]
})
export class AbnValidatorDirective implements Validator {
  validator: ValidatorFn;

  constructor() {
    this.validator = this.abnValidator();

   }


   validate(c: FormControl) {
    return this.validator(c);
  }
   abnValidator(): ValidatorFn  {
    return (control: FormControl) => {
      if (control.value) {
        var weights = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19],
          abn = control.value.trim().replace(/[^\d]/g, ''),
          result = false;
  
        // check length is 11 digits
        if (abn.length === 11) {
  
          // apply ato check method
          var sum = 0,
            weight;
  
          for (var index = 0; index <= weights.length - 1; index++) {
            weight = weights[index];
            var digit = abn[index] - (index ? 0 : 1);
            sum += weight * digit;
          }
  
          result = sum % 89 === 0;
        }
        if(!result){
          return {abnValidator: { valid: false }};
        }else{
          return null;
        }
      }
    };
    
  }

}
